/* eslint-disable jsx-a11y/label-has-associated-control */

import { useEffect, useState } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Dropdown } from '@zeeve-platform/dropdown-component';
import Footer from '../../../components/common/nextAndPrev';
import {
  getNetworkDetailData,
  getNetworkList,
} from '../../../services/apisService';
import Urls from '../../../utils/util';
import { NetworkDataZoneTypes } from '../declaration';

// Types of Props
interface Props {
  first: boolean;
  prev: () => void;
  nextPage: () => void;
  setNetworkDataZone: (obj: NetworkDataZoneTypes) => void;
  submit: () => void;
  last: boolean;
  networkDataZone: NetworkDataZoneTypes;
  networkId: string;
}

interface NetworkTypeInterfce {
  id: number | string;
  chainId: string | number;
  networkName: string;
  network: string;
  defaultConfig: {
    apis: string[];
    syncMode: string;
    gcMode: string;
  };
}

const Network = ({
  first,
  prev,
  nextPage,
  setNetworkDataZone,
  last,
  networkDataZone,
  submit,
  networkId,
}: Props) => {
  // States Define
  const [showNext, setNext] = useState({
    s1: false,
    s2: false,
    s3: false,
    s4: false,
    s5: false,
  });

  const [valid, setValid] = useState(true);

  // Variables Declarations
  const deploymentId = Urls.getDeploymentId();
  const rpcAccessPoint = ['HTTP', 'WS'];

  const getNewtworkListAndDetails = async () => {
    let networkType = 'fail';

    const networkData: any = await getNetworkDetailData(networkId);
    if (networkData && networkData.success) {
      const res = networkData.data;
      networkType = res.network;
    }

    const networkList: any = await getNetworkList(networkType, 'dedicated');
    if (networkList && networkList.success) {
      setDefaults(networkList.data[0]);
    }
  };

  useEffect(() => {
    // Api's call for network list and network details
    getNewtworkListAndDetails();
  }, []);

  const setDefaults = (obj: NetworkTypeInterfce) => {
    setNetworkDataZone({
      ...networkDataZone,
      nodeOption: '',
      unsafeRPC: false,
      network: obj.network ? obj.network : '',
      networkName: obj.networkName,
    });
    setNext({ ...showNext, s4: true });
  };

  const unsetHighlight = (x: string, flag: boolean) => {
    const b = document.getElementById(x);
    if (b) {
      if (flag) {
        if (b.classList.contains('formEmptyText')) {
          b.classList.remove('formEmptyText');
        }
      } else {
        b.style.borderColor = '#ECEEF3';
      }
    }
  };
  const highlight = (x: string, flag: boolean) => {
    const b = document.getElementById(x);
    if (b) {
      if (flag) {
        if (!b.classList.contains('formEmptyText')) {
          b.classList.add('formEmptyText');
        }
      } else {
        b.style.borderColor = 'red';
      }
    }
  };

  const handleInput = (val: string, op: string) => {
    const usernamePattern = /[^a-zA-Z0-9]/g;
    const etag = document.getElementById('err');
    let res;
    switch (op) {
      case 'user':
        res = val.match(usernamePattern);
        if (res) {
          highlight('z15', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Invalid username format. Use only alphabets and digits.';
          }
        } else if (val.length < 8) {
          highlight('z15', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the username should not be less than 8.';
          }
        } else if (val.length > 20) {
          highlight('z15', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the username should not be more than 20.';
          }
        } else {
          setValid(true);
          unsetHighlight('z15', false);
          if (etag) {
            etag.style.display = 'none';
          }
          setNext({ ...showNext, s1: true });
          setNetworkDataZone({ ...networkDataZone, username: val });
        }
        break;
      case 'pass':
        res = val.match(usernamePattern);
        if (res) {
          highlight('z12', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Invalid password format. Use only alphabets and digits.';
          }
        } else if (val.length < 8) {
          highlight('z12', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the password should not be less than 8.';
          }
        } else if (val.length > 20) {
          highlight('z12', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the password should not be more than 20.';
          }
        } else {
          unsetHighlight('z12', false);
          setValid(true);
          if (etag) {
            etag.style.display = 'none';
          }
          setNext({ ...showNext, s2: true });
          setNetworkDataZone({ ...networkDataZone, password: val });
        }
        break;
      case 'instanceName':
        if (val.length < 5) {
          highlight('instanceName', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the node name should not be less than 5.';
          }
          break;
        } else if (val.length > 20) {
          highlight('instanceName', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Length of the node name should not be more than 20.';
          }
          break;
        } else if (!/[a-z]/i.test(val.charAt(0))) {
          highlight('instanceName', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name should start with an alphabet.';
          }
          break;
        } else if (!/^[A-Za-z0-9]*$/.test(val.charAt(val.length - 1))) {
          highlight('instanceName', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name should end with an alphabet or a   number.';
          }
          break;
        } else if (!/^([A-Za-z0-9\s-])*$/.test(val)) {
          highlight('instanceName', false);
          setValid(false);
          if (etag) {
            etag.style.display = 'block';
            etag.innerHTML = 'Node name can only contain alphabet, number, space and hyphen.';
          }
          break;
        } else {
          if (etag) {
            etag.style.display = 'none';
          }
          setValid(true);
          setNetworkDataZone({ ...networkDataZone, instanceName: val });
          unsetHighlight('instanceName', false);
          setNext({ ...showNext, s3: true });
        }
        break;
      default:
        break;
    }
  };

  const solve = () => {
    if (
      (showNext.s1 || networkDataZone.username)
      && (showNext.s2 || networkDataZone.password)
      && (showNext.s3 || networkDataZone.instanceName)
      && (showNext.s4 || checkAccessPoint())
      && (showNext.s5 || networkDataZone.nodeOption)
      && valid
    ) {
      return nextPage();
    }

    if (!(showNext.s1 || networkDataZone.username)) {
      return highlight('z15', false);
    }
    if (!(showNext.s2 || networkDataZone.password)) {
      return highlight('z12', false);
    }
    if (!(showNext.s3 || networkDataZone.instanceName)) {
      return highlight('instanceName', false);
    }
    if (!(showNext.s4 || checkAccessPoint())) {
      return highlight('z13', true);
    }
    if (!(showNext.s5 || networkDataZone.nodeOption)) {
      return highlight('nodeOption', true);
    }
    return highlight('z123', false);
  };
  const checkAccessPoint = () => {
    if (networkDataZone && networkDataZone.rpcAccessPoint) {
      return (
        networkDataZone.rpcAccessPoint.https
        || networkDataZone.rpcAccessPoint.wss
      );
    }
    return false;
  };
  const handleRpcAccessPoint = (op: string) => {
    if (op === 'https') {
      const old = networkDataZone.rpcAccessPoint;
      if (old) {
        old.https = !old.https;
        setNetworkDataZone({ ...networkDataZone, rpcAccessPoint: old });
      } else {
        const obj = { https: true, wss: false };
        setNetworkDataZone({ ...networkDataZone, rpcAccessPoint: obj });
      }
    }
    if (op === 'wss') {
      const old = networkDataZone.rpcAccessPoint;
      if (old) {
        old.wss = !old.wss;
        setNetworkDataZone({ ...networkDataZone, rpcAccessPoint: old });
      } else {
        const obj = { https: false, wss: true };
        setNetworkDataZone({ ...networkDataZone, rpcAccessPoint: obj });
      }
    }
    unsetHighlight('z13', true);
  };

  return (
    <>
      <div className="col-11 mx-auto">
        <div className="row">
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-4 col-11 form-floating cordaversion">
              <h6 className="mx-3 mt-4">Network Type</h6>
              <Dropdown
                id="z14"
                className="form-borderradius form-select mx-2 mt-3"
                dropDownStyle={{ height: '50px' }}
                defaultValue={networkDataZone.networkName}
                options={[
                  {
                    value: networkDataZone.networkName,
                    label: networkDataZone.networkName,
                  },
                ]}
                onChange={() => {
                  unsetHighlight('z14', false);
                }}
                selectTitle={networkDataZone.networkName}
                disabled
              />
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-4 col-11 marginauto form-floating cordaversion">
              <h6 className="mx-3 mt-3">Deployment Type</h6>
              <Dropdown
                id="z17"
                className="form-borderradius form-select mx-2 mt-3"
                dropDownStyle={{ height: '50px' }}
                defaultValue={networkDataZone.deploymentType}
                options={[
                  { value: deploymentId, label: 'Native Polkadot Deployment' },
                ]}
                onChange={(e) => {
                  unsetHighlight('z17', false);
                  setNext({ ...showNext, s5: true });
                  setNetworkDataZone({
                    ...networkDataZone,
                    deploymentType: e.target.value,
                  });
                }}
                selectTitle="Native Polkadot Deployment"
                disabled
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="mt-4 col-8 ms-3"
            title="credentials required to access RPC server"
          >
            <h6>
              RPC Acces Credentials
              <i className=" mx-1 fa fa-info-circle" />
            </h6>
          </div>
          <div
            className="mt-4 col-3"
            title="Numerous people are using telemetry so it is recommended that you choose a node name something likely to be unique."
          >
            <h6>
              Node Name
              <i className="mx-1 fa fa-info-circle" />
            </h6>
          </div>
        </div>
        <div className="row ms-1">
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-3 col-11 form-floating cordaversion">
              <Inputbox
                type="text"
                className="form-control required"
                defaultValue={networkDataZone.username}
                autoComplete="off"
                placeholder="username"
                id="z15"
                onChange={(e: { target: { value: string } }) => {
                  handleInput(e.target.value, 'user');
                }}
              />
              <label htmlFor="z15" className="form-pswd">
                Username
              </label>
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-3 col-11 form-floating cordaversion">
              <Inputbox
                type="password"
                className="form-control required"
                defaultValue={networkDataZone.password}
                placeholder="password"
                id="z12"
                autoComplete="off"
                onChange={(e: { target: { value: string } }) => {
                  handleInput(e.target.value, 'pass');
                }}
              />
              <label htmlFor="z12" className="form-pswd">
                Password
              </label>
            </div>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div className="mt-3 col-11 marginauto form-floating cordaversion">
              <Inputbox
                type="text"
                className="form-control required"
                id="instanceName"
                placeholder="Node Name"
                defaultValue={networkDataZone.instanceName}
                onChange={(e: { target: { value: string } }) => {
                  handleInput(e.target.value, 'instanceName');
                }}
              />
              <label htmlFor="instanceName" className="form-pswd">
                Node Name
              </label>
            </div>
          </div>
        </div>
        <div className="row ms-3 mt-5 mb-3">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <h6 id="z13">Enable RPC Server</h6>
            <div className="row mt-3 mx-2">
              <div className="form-check col-xl-4 col-lg-4 col-sm-4 col-md-4">
                <Inputbox
                  type="checkbox"
                  className="form-check-input"
                  id={`custom-checkbox-rpc-${0}`}
                  checked={
                    networkDataZone.rpcAccessPoint
                      ? networkDataZone.rpcAccessPoint.https
                      : false
                  }
                  onChange={() => {
                    handleRpcAccessPoint('https');
                  }}
                />
                <label
                  className="form-check-label mx-2"
                  htmlFor={`custom-checkbox-rpc-${0}`}
                >
                  {rpcAccessPoint[0]}
                </label>
              </div>
              <div className="form-check col-xl-4 col-lg-4 col-sm-4 col-md-4">
                <Inputbox
                  type="checkbox"
                  className="form-check-input"
                  id={`custom-checkbox-rpc-${1}`}
                  checked={
                    networkDataZone.rpcAccessPoint
                      ? networkDataZone.rpcAccessPoint.wss
                      : false
                  }
                  onChange={() => {
                    handleRpcAccessPoint('wss');
                  }}
                />
                <label
                  className="form-check-label mx-2"
                  htmlFor={`custom-checkbox-rpc-${1}`}
                >
                  {rpcAccessPoint[1]}
                </label>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="col-11 form-floating cordaversion">
              <h6 className="mx-2 mb-3" id="nodeOption">
                Node Type
              </h6>
              <div className="row mx-2">
                <div className="form-check col-xl-6 col-lg-6 col-sm-6 col-md-6">
                  <Inputbox
                    name="nodeOption"
                    type="radio"
                    className="form-check-input"
                    value="full"
                    id="custom-radio-nodeoption-0"
                    checked={networkDataZone.nodeOption === 'full'}
                    onChange={(e: { target: { value: any } }) => {
                      setNetworkDataZone({
                        ...networkDataZone,
                        nodeOption: e.target.value,
                      });
                      unsetHighlight('nodeOption', true);
                      setNext({ ...showNext, s5: true });
                    }}
                  />
                  <label
                    className="form-check-label mx-2"
                    htmlFor="custom-radio-nodeoption-0"
                  >
                    Full
                  </label>
                  <i
                    title="Full node type for syncing chain of Polkadot."
                    className="mx-2 fa fa-info-circle"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p
          id="err"
          className="text-center mt-4 mb-4"
          style={{ color: 'red', display: 'none' }}
        >
          Error
        </p>
      </div>
      <Footer
        last={last}
        submit={submit}
        showNext={false}
        first={first}
        nextPage={solve}
        prev={prev}
      />
    </>
  );
};
export default Network;
